import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class WithdrawApi {
  static uri = "Withdraw";
  static uri2 = "a/accounts/withdraw";
  context: AuthContextProps;
  constructor(context: AuthContextProps) {
    this.context = context;
  }
  getAll(page: number, rows: number) {
    return getData({
      uri: WithdrawApi.uri,
      params: `?page=${page}&rows=${rows}`,
      context: this.context,
    });
  }

  get(id: number) {
    return getData({
      uri: WithdrawApi.uri2,
      id: id,
      context: this.context,
    });
  }
}
